var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 21,
    viewBox: "0 0 57 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 1.09524,
    fill: "#203468"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 9.95312,
    width: 57,
    height: 1.09524,
    fill: "#203468"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 19.9043,
    width: 57,
    height: 1.09524,
    fill: "#203468"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconDark);
export default __webpack_public_path__ + "static/media/menu_icon_dark.77c2081ddf36febb6568f2171e2e59e8.svg";
export { ForwardRef as ReactComponent };